import React from 'react'
import DeliverySelectDesiny from "../../../DeliveryService/DeliverySelectDestiny"

export default function AddressPickerHisopado() {
    return (
        <div className="allwhite-hisopados-background">
                <DeliverySelectDesiny />
        </div>)
}
